import { type PhoneType } from '../enums/phonetype.enum';

export class PhoneInfo {
  public Order?: number;
  public ContactId?: string;
  public Number?: string;
  public Type?: PhoneType;
  public IsPrimary?: boolean;
  public IsActive?: boolean;
}
